module.exports = __webpack_public_path__ + "static/media/close_icon.0ee48a8f.svg";